module.exports = __webpack_public_path__ + "static/media/temp-perfil-2.8005698a.jpg";